import { useHasUserPermission } from '@/stores/auth'

export const allowedEditPastProgram = useHasUserPermission(['program.update_schedule'])
